/**
 * CRBR Solutions — Panier de devis (quote basket)
 * Stockage 100% côté client (localStorage). Ne touche jamais au panier
 * Shopify réel : aucun ajout au panier, aucun paiement en ligne possible.
 * Les données ne quittent le navigateur qu'au moment de l'envoi du
 * formulaire natif sur /pages/devis.
 */
(function () {
  var STORAGE_KEY = 'crbr_devis_v1';

  function readState() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return { lines: [], shootingHouse: null };
      var parsed = JSON.parse(raw);
      return {
        lines: Array.isArray(parsed.lines) ? parsed.lines : [],
        shootingHouse: parsed.shootingHouse || null,
      };
    } catch (e) {
      return { lines: [], shootingHouse: null };
    }
  }

  function count(state) {
    var n = 0;
    for (var i = 0; i < state.lines.length; i++) n += state.lines[i].qty;
    if (state.shootingHouse) n += 1;
    return n;
  }

  function updateBadges(state) {
    var n = count(state);
    var badges = document.querySelectorAll('[data-devis-badge]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = n;
      badges[i].hidden = n === 0;
    }
  }

  function writeState(state) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {
      /* stockage indisponible (navigation privée, etc.) : on continue sans persister */
    }
    document.dispatchEvent(new CustomEvent('crbr:devis:change', { detail: state }));
    updateBadges(state);
  }

  function addLine(line, qty) {
    qty = qty || 1;
    var state = readState();
    var existing = null;
    for (var i = 0; i < state.lines.length; i++) {
      if (state.lines[i].id === line.id) {
        existing = state.lines[i];
        break;
      }
    }
    if (existing) {
      existing.qty += qty;
    } else {
      state.lines.push({
        id: line.id,
        name: line.name,
        family: line.family || '',
        unit: line.unit || '',
        qty: qty,
      });
    }
    writeState(state);
    return state;
  }

  function setQty(id, qty) {
    var state = readState();
    qty = Math.max(1, parseInt(qty, 10) || 1);
    for (var i = 0; i < state.lines.length; i++) {
      if (state.lines[i].id === id) state.lines[i].qty = qty;
    }
    writeState(state);
    return state;
  }

  function removeLine(id) {
    var state = readState();
    state.lines = state.lines.filter(function (l) {
      return l.id !== id;
    });
    writeState(state);
    return state;
  }

  function setShootingHouse(request) {
    var state = readState();
    state.shootingHouse = request;
    writeState(state);
    return state;
  }

  function clearAll() {
    var state = { lines: [], shootingHouse: null };
    writeState(state);
    return state;
  }

  function buildSummaryText(state) {
    var lines = ['DEMANDE DE DEVIS — CRBR SOLUTIONS', ''];
    lines.push('--- MATERIEL DEMANDE ---');
    if (state.lines.length === 0) {
      lines.push('(aucun article ajoute depuis le catalogue)');
    } else {
      state.lines.forEach(function (l) {
        var unitTxt = l.unit ? ' ' + l.unit + '(s)' : '';
        lines.push('- ' + l.name + ' (' + l.family + ') — quantite : ' + l.qty + unitTxt);
      });
    }
    if (state.shootingHouse) {
      var sh = state.shootingHouse;
      lines.push('', '--- SHOOTING HOUSE - DEMANDE D’ETUDE ---');
      lines.push('Format : ' + (sh.format || '—'));
      lines.push('Surface disponible : ' + (sh.surface || '—'));
      lines.push('Environnement : ' + (sh.environment || '—'));
      lines.push('Effectifs a entrainer : ' + (sh.effectifs || '—'));
      lines.push('Delai souhaite : ' + (sh.delai || '—'));
      lines.push('Scenarios vises : ' + (sh.scenarios || '—'));
    }
    return lines.join('\n');
  }

  window.crbrDevis = {
    getState: readState,
    add: addLine,
    setQty: setQty,
    remove: removeLine,
    setShootingHouse: setShootingHouse,
    clear: clearAll,
    count: function () {
      return count(readState());
    },
    buildSummaryText: buildSummaryText,
  };

  // Délégation d'événements : tout élément [data-devis-add] sur la page
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest && evt.target.closest('[data-devis-add]');
    if (!btn) return;
    evt.preventDefault();
    addLine({
      id: btn.getAttribute('data-devis-id'),
      name: btn.getAttribute('data-devis-name'),
      family: btn.getAttribute('data-devis-family'),
      unit: btn.getAttribute('data-devis-unit') || '',
    });

    var textEl = btn.querySelector('[data-devis-add-label]');
    var original = textEl ? textEl.textContent : null;
    var addedLabel = btn.getAttribute('data-devis-added-label') || 'Ajouté ✓';
    btn.classList.add('is-added');
    if (textEl) textEl.textContent = addedLabel;
    window.setTimeout(function () {
      btn.classList.remove('is-added');
      if (textEl && original) textEl.textContent = original;
    }, 1600);
  });

  function init() {
    updateBadges(readState());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
